export const BACKGROUND_OPACITY = 0.18;
export const COLOR_OPACITY = 0.5;
export const CHAT_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
export const ASCEND_LANDING_PAGE_URL =
  'https://www.wix.com/ascend/home?utm_campaign=vir_wixad_chat';
